import React, { Component } from 'react';
import _ from 'underscore';
import { FormattedMessage, injectIntl } from 'react-intl';
import ModalActionCreator from 'action_creators/modal';
import { toCurrency } from 'views/anyguide/bookings/cancel/v2/utilities/utilities';
import { CancellationPolicyText } from 'views/plugins/confirmation/styles';

import './BookingSummary.scss';

_.mixin(require('lib/underscore_extensions'));
_.str = require('underscore.string/index.js');

class BookingSummary extends Component {
  showCancellationPolicy = (e) => {
    const cancellationPolicy = this.props.cancellation_policy.description;

    const modalContent = (
      <div className="cancellationPolicyModal">
        <div className="title">
          {this.props.intl.formatMessage({
            defaultMessage: 'Cancellation policy',
          })}
        </div>
        <div className="policy">{cancellationPolicy}</div>
      </div>
    );

    let modalSettings = {
      content: modalContent,
      triggeringElement: e.currentTarget,
    };

    // Mobile options
    if (window.innerWidth <= 760) {
      modalSettings = {
        ...modalSettings,
        className: 'full-screen',
        showIcon: false,
        settings: {
          transition: 'slide up',
        },
      };
    }

    ModalActionCreator.show(modalSettings);
  };

  calculateTotal = () => {
    const { price } = this.props;
    return price || toCurrency(0);
  };

  // Determines title to display
  // Total or Deposit
  determinePaymentTitle = () => {
    const { payments } = this.props;

    let title = this.props.intl.formatMessage({ defaultMessage: 'Total' });
    const totalPayments = [
      'Payment',
      'Final Payment',
      'Full Payment',
      'Refund',
      'Adjustment',
    ]; // 'Total'
    const depositPayments = ['Deposit']; // 'Deposit'

    payments.forEach((payment) => {
      const { paid, type } = payment;
      if (paid) {
        if (totalPayments.includes(type)) {
          title = this.props.intl.formatMessage({ defaultMessage: 'Total' });
        } else if (depositPayments.includes(type)) {
          title = this.props.intl.formatMessage({ defaultMessage: 'Deposit' });
        }
      }
    });

    return title;
  };

  render() {
    const {
      tour,
      formattedDate,
      formattedTime,
      numberOfGuests,
      link_color,
      tour_name_translation,
      cancellation_policy,
      hasResource,
      resource,
      guestsDescriptor,
    } = this.props;
    const linkStyle = { color: link_color };

    return (
      <div className="bookingSummary">
        <div
          className="coverPicture"
          style={{ backgroundImage: `url('${tour.cover_picture}')` }}
        />
        <div className="infoPanel">
          <div className="tourName">{tour_name_translation}</div>
          <div className="businessName">
            <FormattedMessage
              id="WITH_NAME"
              defaultMessage="With {name}"
              values={{
                name: hasResource ? resource.name : tour.business_name,
              }}
            />
          </div>
          <div className="details">
            <div className="detail">
              <span className="detailType">
                <FormattedMessage id="DATE" defaultMessage="Date" />
              </span>
              <span className="value">{formattedDate}</span>
            </div>
            <div className="detail">
              <span className="detailType">
                <FormattedMessage id="TIME" defaultMessage="Time" />
              </span>
              <span className="value">{formattedTime}</span>
            </div>
            <div className="detail">
              <span className="detailType">
                <FormattedMessage
                  id="NUMBER_OF_DESCRIPTOR"
                  defaultMessage="Number of {descriptor}"
                  values={{ descriptor: guestsDescriptor }}
                />
              </span>
              <span className="value">{numberOfGuests}</span>
            </div>
          </div>
          <div className="cancellationPolicy">
            <CancellationPolicyText inlineSize={50}>
              <FormattedMessage
                id="CANCELLATION_POLICY"
                defaultMessage="Cancellation policy"
              />
            </CancellationPolicyText>
            <span
              data-testid="cancellation-policy"
              className="dotted brand-color policyName"
              onClick={this.showCancellationPolicy}
              onKeyDown={(e) =>
                !e.key.includes('Tab') && this.showCancellationPolicy(e)
              }
              style={linkStyle}
            >
              {_.str.truncate(cancellation_policy.name, 40)}
            </span>
          </div>
          <div className="priceBreakdown">
            <span className="total">{this.determinePaymentTitle()}:</span>
            <span
              className="totalAmount"
              data-testid="total-amount-reschedule-page"
            >
              {this.calculateTotal()}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(BookingSummary);
